export const config = {
    headerImg: require('@/assets/images/partner/header.png'),
    headerTitle: '数智领袖，共创未来',
    headerDesc: '敬在医疗信息化生态圈，欢迎您的加入',
    title: '我们为生态圈合作伙伴提供',
    contentData: [
        {
            src: require('@/assets/images/partner/contentImg1.png'),
            title: '领先的产品及前沿技术',
            info: '全新一代医院智慧运营管理平台，产品框架及设计全面满足五级政策要求，独立知识产权的一体化自研产品，拥有百余位医疗领域头部客户，经过验证的产品稳定可靠。'
        },
        {
            src: require('@/assets/images/partner/contentImg2.png'),
            title: '可靠的伙伴生态',
            info: '敬在信息全面开放生态伙伴资源，与生态伙伴携手合作、共建共赢、共建医院智慧运营管理新生态。'
        },
        {
            src: require('@/assets/images/partner/contentImg3.png'),
            title: '强大的市场资源',
            info: '协助生态伙伴联合进行市场推广，标杆案例宣传、品牌形象授权、主题沙龙会、先进营销工具，助力生态伙伴拓展医院智慧运营管理软件市场。'
        },
        {
            src: require('@/assets/images/partner/contentImg4.png'),
            title: '资深的培训认证',
            info: '面向生态伙伴提供学院制的培训课程服务，线上/线下多渠道联动，提供专业的产品、解决方案、咨询服务、认证培训、大咖私享会，全面提升合作伙伴的专业能力。'
        },
    ],
    partnerTitle: '如何成为敬在合作伙伴',
    partnerData: [
        {
            src: require('@/assets/images/partner/footerIcon1.png'),
            title: '我们为合作伙伴提供',
            info: '我们都能帮助你构建、实施和运行合适的智慧管理解决方案，并提供相关维护和支持服务，满足你的独特需求。'
        },
        {
            src: require('@/assets/images/partner/footerIcon2.png'),
            title: '提交合作申请',
            info: '准备好企业资质、合作规划等相关材料，通过官方渠道提交合作申请，清晰阐述合作诉求与优势，确保申请信息准确完整，以便快速进入审核流程。'
        },
    ],
    bottomClick: {
        title: '敬在医疗信息化生态伙伴圈',
        button: '欢迎您的加入'
    }
}
